import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export function scrollToAccountSettingsPanel(panelId: string): boolean {
  const panelEl = document.getElementById(panelId);
  if (!panelEl) {
    return false;
  }

  panelEl.scrollIntoView({behavior: 'smooth', block: 'start'});
  return true;
}

/**
 * Прокрутка к секции настроек аккаунта по hash в URL (например #telegram-connection).
 */
export function useAccountSettingsHashScroll(isReady: boolean) {
  const {hash} = useLocation();

  useEffect(() => {
    if (!isReady || !hash) {
      return;
    }

    const panelId = decodeURIComponent(hash.slice(1));
    if (!panelId) {
      return;
    }

    let attempts = 0;
    let timeoutId: number | undefined;

    const tryScroll = () => {
      if (scrollToAccountSettingsPanel(panelId)) {
        return;
      }

      attempts += 1;
      if (attempts < 15) {
        timeoutId = window.setTimeout(tryScroll, 50);
      }
    };

    timeoutId = window.setTimeout(tryScroll, 0);

    return () => {
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [hash, isReady]);
}
